import React from 'react';
import PropTypes from 'prop-types';
import { fade, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ListaErros from './ListaErros.js';

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        transition: theme.transitions.create(['border-color', 'background-color'])
    },
    comErro: {
        border: `1px solid ${theme.palette.error.main}`,
        borderLeftWidth: 4,
        backgroundColor: fade(theme.palette.error.main, 0.04),
        padding: theme.spacing(2)
    }
}));

/*
 * Destaca em vermelho apenas o bloco do formulário que está com pendência e,
 * quando informado, lista dentro dele o que falta corrigir. Sem erro o bloco
 * é renderizado sem nenhuma moldura.
 */
export default function BlocoErro({ erro = false, itens = [], titulo, className, children }) {
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, erro && classes.comErro, className)}>
            {erro && <ListaErros titulo={titulo} itens={itens} />}
            {children}
        </div>
    );
}

BlocoErro.propTypes = {
    erro: PropTypes.bool,
    itens: PropTypes.arrayOf(PropTypes.string),
    titulo: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
};
